//action => {type:"LOADING",payload:{context:string,loading:boolean}}
export default function loadingReducer(state = {}, action) {
  if (action.type === "LOADING") {
    let newState = { ...state };
    newState[action.payload.context] = {
      loading: action.payload.loading,
    };
    return newState;
  }
  return state;
}
